export default '3F2BA';
